import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Button } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import classnames from 'classnames';
import styles from "./styles/buttonSwitch";
const useStyles = createUseStyles(styles, 'OperationSwitch');
const OperationSwitch = _ref => {
  let {
    onChange,
    value
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const rootClassName = classnames(classes.root);
  const buttons = useMemo(() => [{
    label: t('cfm_label_condition_and'),
    value: 'and'
  }, {
    label: t('cfm_label_condition_or'),
    value: 'or'
  }], [t]);
  const buttonsEl = useMemo(() => buttons.map(button => {
    const buttonClassName = classnames(classes.button, {
      [classes.active]: button.value === value
    });
    return /*#__PURE__*/React.createElement(Button, {
      key: button.value,
      type: "terciary",
      className: buttonClassName,
      onClick: () => onChange && onChange(button.value)
    }, button.label);
  }), [buttons, classes.active, classes.button, onChange, value]);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName
  }, buttonsEl);
};
process.env.NODE_ENV !== "production" ? OperationSwitch.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any
} : void 0;
export default /*#__PURE__*/memo(OperationSwitch);